import React from "react";
import { ShimmerBlock } from "../common/Skeleton";

export default function LeaveApprovalSkeleton({
  rows = 5,
}: {
  rows?: number;
}) {
  return (
    <div className="space-y-4" role="status" aria-busy="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="rounded-[16px] bg-[var(--color-bg-base)] border border-[var(--color-border-primary)] shadow-[var(--shadow-sm)] p-5 animate-pulse"
        >
          <div className="flex items-start gap-4 flex-wrap">
            <div className="flex items-center gap-3 min-w-[200px]">
              <ShimmerBlock className="w-[48px] h-[48px] rounded-[13px]" />
              <div className="space-y-2">
                <ShimmerBlock className="h-4 w-32" />
                <ShimmerBlock className="h-3 w-24" />
              </div>
            </div>
            <div className="flex-1 min-w-[200px] flex flex-wrap gap-5">
              <div className="space-y-2">
                <ShimmerBlock className="h-3 w-10" />
                <ShimmerBlock className="h-4 w-20" />
              </div>
              <div className="space-y-2">
                <ShimmerBlock className="h-3 w-10" />
                <ShimmerBlock className="h-4 w-36" />
              </div>
              <div className="flex-1 min-w-[160px] space-y-2">
                <ShimmerBlock className="h-3 w-10" />
                <ShimmerBlock className="h-4 w-full max-w-[200px]" />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between flex-wrap gap-3 mt-4 pt-4 border-t border-[var(--color-border-primary)]">
            <ShimmerBlock className="w-4 h-4 rounded" />
            <div className="flex items-center gap-2">
              <ShimmerBlock className="h-10 w-24 rounded-[11px]" />
              <ShimmerBlock className="h-10 w-28 rounded-[11px]" />
            </div>
          </div>
        </div>
      ))}
      <div className="rounded-[16px] bg-[var(--color-bg-base)] border border-[var(--color-border-primary)] shadow-[var(--shadow-sm)]">
        <div className="p-4 flex items-center justify-between">
          <ShimmerBlock className="h-4 w-40" />
          <div className="flex items-center gap-2">
            <ShimmerBlock className="h-8 w-20 rounded" />
            <ShimmerBlock className="h-8 w-8 rounded" />
            <ShimmerBlock className="h-8 w-8 rounded" />
            <ShimmerBlock className="h-8 w-8 rounded" />
            <ShimmerBlock className="h-8 w-16 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}
